import React, { useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Button } from '@mui/material/';
import InputBase from '@mui/material/InputBase';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import SearchIcon from '@mui/icons-material/Search';





const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'auto',
    [theme.breakpoints.up('sm')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 'auto',
    },
    [theme.breakpoints.up('md')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 'auto',
    },
    [theme.breakpoints.up('lg')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 'auto',
    },
    [theme.breakpoints.up('xl')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '30ch',
            '&:focus': {
                width: '30ch',
            },
        },
    },
}));


export default function SearchBar({ setSearchText, searchText, labeltext }) {

    const [newSearch, setNewSearh] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        setSearchText(newSearch)

    }

    const handleChange = (e) => {
        e.preventDefault()
        setNewSearh(e.target.value)
        if (!e.target.value) {
            setSearchText('')
        }
    }

    const handleChange2 = (e) => {

        setNewSearh("")
        setSearchText('')
    }

    return (
        <Box sx={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }}>
            <form onSubmit={handleSubmit} >
                <AppBar position="static" sx={{ alignContent: 'center' }} >

                    <Toolbar>
                        <Button color={"secondary"} variant="contained" onClick={(e) => handleChange2()}>Clear <ClearAllIcon /></Button>
                        <Search>

                            <SearchIconWrapper>
                                <SearchIcon />
                            </SearchIconWrapper>
                            <StyledInputBase
                                value={newSearch}
                                inputProps={{ 'aria-label': 'search' }}

                                onChange={(e) => handleChange(e)}
                                tabIndex={0}


                            />

                        </Search>
                        <Button color={"secondary"} variant="contained" type="submit">Search <SearchIcon /></Button>






                    </Toolbar>

                </AppBar>
            </form>
        </Box >
    );
}